import { MineComponent } from './mine.component';
import { UpdateComponent } from './update/update.component';

export {
  MineComponent as LicenseMineComponent,
  UpdateComponent as LicenseMineUpdateComponent,
};
